const availableValuesTypeRisk = [
  { label: "Opérationnel", value: "Opérationnel", uuid: "b8054ae5-b2b6-4417-b518-a47c0025dafd" },
  { label: "Conformité", value: "Conformité", uuid: "893040d9-269f-44d2-9585-19610ab0a93d" },
  { label: "Juridique", value: "Juridique", uuid: "14e83fa4-0ecb-4b0b-8680-6bfcf496db55" },
  { label: "Fraude", value: "Fraude", uuid: "3a3cd0d6-569b-4bba-a386-5de4dfa5d2d3" },
  {
    label: "Opérationnel/Conformité",
    value: "Opérationnel/Conformité",
    uuid: "75715b4e-5ca5-4f5f-a76f-36ba484843a6",
  },
  { label: "IT", value: "IT", uuid: "c6f564d2-5b33-4ce9-ac3e-3928ecec7188" },
  { label: "Financier", value: "Financier", uuid: "0d132fa6-5120-47fd-95ef-eda517c9345b" },
  { label: "Sécurité", value: "Sécurité", uuid: "e5fd12de-803d-4f1d-8e5c-52689a4464f6" },
]

export const getTypeRiskTranslated = (typeRisk, trad) => {
  // Générique
  if (typeRisk === "Opérationnel") return trad?.OPERATIONAL
  if (typeRisk === "Conformité") return trad?.COMPLIANCE
  if (typeRisk === "Juridique") return trad?.LEGAL
  if (typeRisk === "Fraude") return trad?.FRAUD
  if (typeRisk === "Opérationnel/Conformité") return trad?.OPERATIONAL_CONFORMITE
  if (typeRisk === "IT") return trad?.IT
  if (typeRisk === "Financier") return trad?.FINANCIAL
  if (typeRisk === "Sécurité") return trad?.SECURITY
  // Swan
  if (typeRisk === "litigeCommerciaux") return trad?.LITIGE_COMMERCIAUX
  if (typeRisk === "RisqueCredit") return trad?.RISQUE_CREDIT
  if (typeRisk === "litigeAutorites") return trad?.LITIGE_AUTORITES
  if (typeRisk === "erreursEvaluationRisque") return trad?.ERREURS_EVALUATION_RISQUE
  if (typeRisk === "erreurExecution") return trad?.ERREUR_EXECUTION
  if (typeRisk === "fraudreEtAutres") return trad?.FRAUDE_ET_AUTRES
  if (typeRisk === "defaillanceSysteme") return trad?.DEFAILLANCE_SYSTEME
  if (typeRisk === "risqueLiquidité") return trad?.RISQUE_LIQUIDITE
  if (typeRisk === "perteRessourcesExploitation") return trad?.PERTE_RESSOURCES_EXPLOITATION
  else return typeRisk
}

export const getImpactSelectOptions = trad => {
  const selectImpactOptions = [
    { label: trad?.VERY_HIGH, value: "Très fort" },
    { label: trad?.HIGH, value: "Fort" },
    { label: trad?.MODERATE, value: "Modéré" },
    { label: trad?.LOW, value: "Faible" },
    { label: trad?.VERYLOW, value: "Très faible" },
  ]
  return selectImpactOptions
}

export const getFrequencySelectOptions = trad => {
  const selectFrequencyOptions = [
    { label: trad?.VERY_HIGH_FEMALE, value: "Très élevée" },
    { label: trad?.HIGH_FEMALE, value: "Elevée" },
    { label: trad?.MODERATE, value: "Modérée" },
    { label: trad?.LOW, value: "Faible" },
    { label: trad?.VERYLOW, value: "Très faible" },
  ]
  return selectFrequencyOptions
}

export const getRiskBrutSelectOptions = trad => {
  const selectRiskBrutOptions = [
    { label: trad?.CRITICAL, value: "Critique" },
    { label: trad?.HIGH, value: "Fort" },
    { label: trad?.MODERATE, value: "Modéré" },
    { label: trad?.LOW, value: "Faible" },
    { label: trad?.VERYLOW, value: "Très faible" },
  ]
  return selectRiskBrutOptions
}

export const getTypeRiskSelectOptions = (riskTypes, trad) => {
  if (riskTypes && Object.keys(riskTypes).length !== 0) return riskTypes.values
  return availableValuesTypeRisk?.map(({ value, label, uuid }) => {
    return {
      label: getTypeRiskTranslated(label, trad),
      value,
      uuid,
    }
  })
}

export const getRiskResiduelSelectOptions = trad => {
  const selectRiskResiduelOptions = [
    { label: trad?.CRITICAL, value: "Critique" },
    { label: trad?.HIGH, value: "Fort" },
    { label: trad?.MODERATE, value: "Modéré" },
    { label: trad?.LOW, value: "Faible" },
    { label: trad?.VERYLOW, value: "Très faible" },
  ]
  return selectRiskResiduelOptions
}

export const getRiskResiduelV2SelectOptions = trad => {
  const selectRiskResiduelOptions = [
    { label: trad?.CRITICAL, value: "veryHigh" },
    { label: trad?.HIGH, value: "high" },
    { label: trad?.MODERATE, value: "moderate" },
    { label: trad?.LOW, value: "low" },
    { label: trad?.VERYLOW, value: "veryLow" },
  ]
  return selectRiskResiduelOptions
}

export const getLevelRiskSelectOptions = trad => {
  const selectLevelRiskOptions = [
    { label: trad?.RISK_PRIMARY, value: 1 },
    { label: trad?.RISK_SECONDARY, value: 2 },
  ]
  return selectLevelRiskOptions
}

export const listConditionRiskResidual = [
  {
    id: "cdbc34b4-ec39-444d-afa0-99f2e1238bc1",
    frequency: "Très faible",
    impact: "Très faible",
    riskBrut: "Très faible",
  },
  {
    id: "fdc99a20-b192-4a3f-b721-1e52b3a1cc56",
    frequency: "Très faible",
    impact: "Faible",
    riskBrut: "Très faible",
  },
  {
    id: "626943b8-37f4-4b9f-a5cd-a19da38fcf18",
    frequency: "Très faible",
    impact: "Modéré",
    riskBrut: "Faible",
  },
  {
    id: "75be77b6-064b-4027-8235-bf6453279b7c",
    frequency: "Très faible",
    impact: "Fort",
    riskBrut: "Modéré",
  },
  {
    id: "052dca2e-0c4f-4fca-bb40-abde5538b269",
    frequency: "Très faible",
    impact: "Très fort",
    riskBrut: "Modéré",
  },
  {
    id: "585883fc-05da-4f35-8115-fde64ac27b5f",
    frequency: "Très élevée",
    impact: "Très faible",
    riskBrut: "Modéré",
  },
  {
    id: "38d0f9bf-357d-4422-a0d2-c66920b9aba5",
    frequency: "Elevée",
    impact: "Très faible",
    riskBrut: "Modéré",
  },
  {
    id: "f48c3b6d-6aeb-456d-929e-69540ad16e06",
    frequency: "Modérée",
    impact: "Très faible",
    riskBrut: "Faible",
  },
  {
    id: "08dd30d5-640e-47b1-a28a-96ce9b1b3ea9",
    frequency: "Faible",
    impact: "Très faible",
    riskBrut: "Faible",
  },
  {
    id: "92467115-145d-44d6-8677-df3521445355",
    frequency: "Très élevée",
    impact: "Faible",
    riskBrut: "Fort",
  },
  {
    id: "4e37a04d-36d3-4b33-95cc-5638432e0252",
    frequency: "Elevée",
    impact: "Faible",
    riskBrut: "Fort",
  },
  {
    id: "d8f39ec1-8151-4bd7-877a-c3fe8b670c1b",
    frequency: "Modérée",
    impact: "Faible",
    riskBrut: "Modéré",
  },
  {
    id: "34f3fa51-7127-442c-b85a-13c56f000490",
    frequency: "Faible",
    impact: "Faible",
    riskBrut: "Faible",
  },
  {
    id: "446f346f-a84d-4a39-855b-69ce2455145b",
    frequency: "Très élevée",
    impact: "Modéré",
    riskBrut: "Critique",
  },
  {
    id: "fffa466a-4152-4b7e-97dd-b92b59cfc2c8",
    frequency: "Elevée",
    impact: "Modéré",
    riskBrut: "Fort",
  },
  {
    id: "dee24af7-1f98-4973-8ffe-6fed2baedfe6",
    frequency: "Modérée",
    impact: "Modéré",
    riskBrut: "Modéré",
  },
  {
    id: "6d2ac4ae-4b4c-4bd0-8323-a5bc8dab1985",
    frequency: "Faible",
    impact: "Modéré",
    riskBrut: "Modéré",
  },
  {
    id: "e9d079fc-48b1-40de-bf09-6ea61707b2ea",
    frequency: "Très élevée",
    impact: "Fort",
    riskBrut: "Critique",
  },
  {
    id: "64589190-358e-43f7-aed5-7e7d79fe0e79",
    frequency: "Elevée",
    impact: "Fort",
    riskBrut: "Critique",
  },
  {
    id: "0538f971-0033-4a89-b4db-5c411df92dc5",
    frequency: "Modérée",
    impact: "Fort",
    riskBrut: "Fort",
  },
  {
    id: "2e88d58d-a64f-420c-87f9-b392bee1a2ff",
    frequency: "Faible",
    impact: "Fort",
    riskBrut: "Modéré",
  },
  {
    id: "a6045bf8-8953-41c9-b7bd-86d28b2a053d",
    frequency: "Très élevée",
    impact: "Très fort",
    riskBrut: "Critique",
  },
  {
    id: "d2a79a9c-67c9-4bf6-a413-743b5ee1b902",
    frequency: "Elevée",
    impact: "Très fort",
    riskBrut: "Critique",
  },
  {
    id: "9ef3a1ab-5234-42dd-80dc-371d9388a02b",
    frequency: "Modérée",
    impact: "Très fort",
    riskBrut: "Fort",
  },
  {
    id: "0fab2e7a-2d29-44b2-a874-cedbd0c51bca",
    frequency: "Faible",
    impact: "Très fort",
    riskBrut: "Fort",
  },
]
